import Button from '@propertypal/web-ui/src/buttons/Button';
import PageWrapper from '@propertypal/web-ui/src/layout/PageWrapper';
import { SubHeading, Text } from '@propertypal/web-ui/src/typography';
import React from 'react';
import { Container, ContentText, BespokeDesignImage } from './BespokeDesign.style';

interface BespokeDesignProps {}

const BespokeDesign: React.FC<BespokeDesignProps> = () => {
  return (
    <Container>
      <PageWrapper>
        <ContentText>
          <SubHeading mb={45} fontSize={60}>
            What about a <span>Bespoke</span> Design?
          </SubHeading>
          <Text fontSize={24} mb={45}>
            If you want something to make you stand out from the crowd and separate you from the rest, we can cater to{' '}
            <b>
              <i>almost</i>
            </b>{' '}
            any request.
          </Text>
          <Text fontSize={24} mb={45}>
            You can benefit from all the features of our template offering, but we will customise the website for you.
          </Text>
          <Button
            onClick={() => document.getElementById('getInTouch')?.scrollIntoView({ behavior: 'smooth' })}
            maxWidth="300px"
            testID="scroll-to-button"
          >
            Let&apos;s chat
          </Button>
        </ContentText>
        <BespokeDesignImage />
      </PageWrapper>
    </Container>
  );
};

export default BespokeDesign;
